import React from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import { Button, Stepper, Step, Card, Grid, CardActions, CardContent, StepLabel, Typography, IconButton, Box, Paper } from '@mui/material';
import { getDataProvisioningWorkflowStateSelector } from '../../../store/dataProvisioningWorkflow/selectors'
import { useDispatch, useSelector } from 'react-redux';
import { disableWorkflow, resetWorkflow, nextStep, prevStep, triggerMainWorkflow } from '../../../store/dataProvisioningWorkflow/actions';
import { STEP_SELECT_DATA_TARGET, STEP_SELECT_DATA_SET, STEP_CREATE_DATA_LOADER } from '../../../store/dataProvisioningWorkflow/actionTypes';
import { useNavigate } from 'react-router-dom';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import * as loaderActions from '../../../store/dataLoader/actions';
import { postDataSelector } from '../../../store/dataLoader/selectors';
import { getRoleClaimsSelector } from '../../../store/auth/selectors';

const steps = ['Select Data Set', 'Select Data Target', 'Configure Data Loader']
export interface TableProps {
    createNewDataLoader?: () => void
    pending?: boolean
    loader?: boolean

};

const DataProvisioningWorkflow = (props: TableProps) => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const loaderResponse = useSelector(postDataSelector)
    const roles = useSelector(getRoleClaimsSelector); // roles  - IDP.Admin or IDP.User

    const [isAdmin, setIsAdmin] = React.useState(true);
    
    React.useEffect(() => {
        if (roles && roles.length > 0) {
            setIsAdmin(roles.includes("IDP.Admin") ? true : false);
        }
    }, [roles]);

    const handleNext = () => {
        dispatch(nextStep())
        if (workflowState['step'] === STEP_SELECT_DATA_SET) {
            navigate("/SelectTarget")
        } else if (workflowState['step'] === STEP_SELECT_DATA_TARGET) {
            navigate("/AddDataLoader")
          
        }
    };

    const handleBack = () => {
        dispatch(prevStep())
        if (workflowState['step'] === STEP_SELECT_DATA_TARGET) {
            navigate("/SearchData")
        } else if (workflowState['step'] === STEP_CREATE_DATA_LOADER) {
            navigate("/SelectTarget")
        }
    };

    const handleReset = () => {
        dispatch(resetWorkflow())
        // dispatch(disableWorkflow())
        navigate("/")
    };

    const cancelWorkflow = () => {
        dispatch(disableWorkflow())
        dispatch(resetWorkflow())
        navigate("/SearchData")
    }

    const viewLoader = (event:React.MouseEvent<HTMLButtonElement>) => {
        dispatch(loaderActions.postDataLoaderReset())
        dispatch(loaderActions.putDataLoaderReset())
        dispatch(resetWorkflow())
        const url = `/ViewDataLoader/${loaderResponse?.batchCode}`
        if (event.ctrlKey) {
            window.open(url,'_blank');
        } else {
        navigate(url)
        }
    }
    
    
    const viewMyAssets = (event:React.MouseEvent<HTMLButtonElement>) => {
        dispatch(loaderActions.postDataLoaderReset())
        dispatch(loaderActions.putDataLoaderReset())
        dispatch(resetWorkflow())
        if (event.ctrlKey) {
            window.open("/",'_blank')
        } else {
            navigate("/")
        }
    }
    
    const workflowState = useSelector(getDataProvisioningWorkflowStateSelector)

    const handleOpenPowerBIUrl = () => {
        window.open('https://powerbi.microsoft.com/en-us/desktop/', '_blank', 'noopener,noreferrer')
    }

    const handleOpenHelpUrl = () => {
        window.open('https://riotinto.sharepoint.com/sites/6002415', '_blank', 'noopener,noreferrer')
    }

    const downloadPowerBIConfiguration = () => {
        var a = document.createElement("a");
        a.href = "syn-rt-prd-unity.sql.azuresynapse.net.pbids"
        a.setAttribute("download", "syn-rt-prd-unity.sql.azuresynapse.net.pbids")
        a.click()
    }

    const startWorkflow = () => {
        dispatch(triggerMainWorkflow())
        handleNext()
    }

    if (!workflowState['isActive']) return null

    let withInitialOptions =
        <Paper sx={{ padding: '20px', backgroundColor: '#f5f5f5' }} elevation={3}>
            <Grid sx={{ flexGrow: 1, }} container spacing={2} justifyContent="center"
                alignItems="center">
                <Grid item xs={9}>
                    <h3>Selected Data Set: DAL_V.VW_{workflowState.selectedDataSet ? workflowState.selectedDataSet.tableId : ''}</h3>
                </Grid>
                <Grid item xs={3} textAlign="right">
                    <Button id="99172614-8d97-4cce-aea7-f05dac85aefa" onClick={cancelWorkflow} >
                        Cancel Workflow
                    </Button>
                </Grid>
            </Grid>
            <Grid sx={{ flexGrow: 1, }} container spacing={1} justifyContent="center" alignItems="center">
                <Grid item xs={4}>
                    <Card sx={{ height: '350px', p: 1 }}>
                        <React.Fragment>
                            <CardContent>
                                <Typography variant="h6" style={{fontSize:'1.2em'}}>
                                    Analyse the Data Set in a SQL tool
                            </Typography>
                            </CardContent>
                            <CardContent>
                                <Typography sx={{ fontSize: 14 }}>
                                    To access the Data Set in-situ tools like SQL Server Management Studio or Azure Data Studio, use the settings below.
                            </Typography>
                            </CardContent>
                            <CardContent>
                                <Typography variant="body2">
                                    Server: <b>syn-rt-prd-unity.sql.azuresynapse.net</b>
                                    <br />
                                    Database: <b>syndwrtprdunity</b>
                                    <br />
                                    Auth: <b>Azure Active Directory - Universal with MFA</b>
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Button id="fec69c29-db53-4db5-954d-60302f2f6c69" size="small" variant="contained" onClick={handleOpenHelpUrl}>Help and FAQs</Button>
                            </CardActions>
                        </React.Fragment>
                    </Card>
                </Grid>
                <Grid item xs={4}>
                    <Card sx={{ height: '350px', p: 1 }}>
                        <React.Fragment>
                            <CardContent>
                                <Typography variant="h6" style={{fontSize:'1.2em'}}>
                                    Visualise the Data Set in Power BI
                            </Typography>
                            </CardContent>
                            <CardContent>
                                <Typography sx={{ fontSize: 14 }}>
                                    Click the download icon below, then open the .pbids file in your downloads folder.
                            </Typography>
                            </CardContent>
                            <CardContent>
                                <IconButton
                                    size="large"
                                    onClick={downloadPowerBIConfiguration}
                                >
                                    <DownloadIcon color="action" style={{ fontSize: '60px' }} />
                                </IconButton>
                            </CardContent>
                            <CardActions>
                                <Button id="4c95486f-ce30-4a1f-aa32-8bb1babe4f29" size="small" onClick={handleOpenPowerBIUrl} variant="contained">Get Power BI Desktop</Button>
                            </CardActions>
                        </React.Fragment>
                    </Card>
                </Grid>
                {isAdmin && <Grid item xs={4}>
                    <Card sx={{ height: '350px', p: 1 }}>
                        <React.Fragment>
                            <CardContent>
                                <Typography gutterBottom variant="h6" style={{fontSize:'1.2em'}}>
                                    Load the Data Set to a Data Target
                            </Typography>
                            </CardContent>
                            <CardContent>
                                <Typography sx={{ fontSize: 14 }}>
                                    Create a Data Loader to load data from the Unity Data Lake into a Data Target.
                                <br /> <br />
                                Configure when the data will be refreshed, and any filters to be applied.
                            </Typography>
                            </CardContent>
                            <CardActions>
                                <Button id="f4ed48f9-35cc-4297-a8c7-d3da28fe4398" size="small" variant="contained" onClick={startWorkflow}>Start the Workflow</Button>
                            </CardActions>
                        </React.Fragment>
                    </Card>
                </Grid>}
            </Grid>
        </Paper>;

    let allStepsCompletedFragment =
        <React.Fragment>
            <Box sx={{ display: 'flex', flexDirection: 'row', p: 1, pt: 4 }} >
                <Typography>
                    All steps completed - you are finished!
                </Typography>
                <Box sx={{ flex: '4 4  auto' }} />
                <Button id="aac9b522-bc0a-4e16-876e-87c1c3d873b8" onClick={viewLoader} color="primary"
                    variant="contained">
                        View Loader
                        </Button>
                <Box sx={{flex:'1 1 auto' }} />
                    <Button id ="myassetaac9b522-bc0a-4e16-876e-87c1c3d873b8"  onClick={viewMyAssets} color="primary" variant="contained">
                        My Assets
                        </Button>
            </Box>
        </React.Fragment>;

    let noInitialOptions =
        <Paper sx={{ padding: '30px', marginTop: '30px' }} elevation={3}>
            <Stepper activeStep={workflowState['step']}>
                {steps.map((label) => {
                    const stepProps: { completed?: boolean } = {};
                    const labelProps: {
                        optional?: React.ReactNode;
                    } = {};
                    return (
                        <Step key={label} {...stepProps}>
                            <StepLabel {...labelProps}>{label}</StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
            {
                workflowState['step'] >= steps.length
                    ? allStepsCompletedFragment
                    :
                    <React.Fragment>
                        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "flex-end", pt: 2, }}>
                            <Button id="00dda108-f6fb-459f-be82-0c71aa50d6e8"
                                color="primary"
                                variant="contained"
                                disabled={workflowState['step'] === STEP_SELECT_DATA_SET}
                                onClick={handleBack}
                                sx={{ mr: 1 }}
                            >
                                Back
                            </Button>
                            {workflowState['step'] === STEP_CREATE_DATA_LOADER ?
                                <>
                                    {props.pending && props.loader ? <>
                                        <LoadingButton
                                            loading
                                            variant="outlined"
                                            size="small"
                                            loadingPosition="start"
                                            startIcon={<SaveIcon />}
                                        >
                                            Processing
                                        </LoadingButton> </> :
                                        <Button id="3b5f4a19-3134-4817-baed-f266e0fc5fd5"
                                            onClick={props.createNewDataLoader}
                                            variant="contained"
                                            disabled
                                        >
                                            Save
                                    </Button>

                                    } </> :
                                    <Button id="820d73ef-4634-4003-b7b7-b5590ab835cd"
                                        onClick={handleNext}
                                        variant="contained"
                                        disabled={
                                            (workflowState['step'] === STEP_SELECT_DATA_SET && workflowState.selectedDataSet === null) ||
                                            (workflowState['step'] === STEP_SELECT_DATA_TARGET && workflowState.selectedDataTarget === null)
                                        }
                                    >
                                        Next
                                    </Button>
                            }
                            <Button id="0291153e-3cce-4010-a472-da133cae6da8" color='inherit' onClick={cancelWorkflow}>
                                Cancel
                            </Button>
                        </Box>
                    </React.Fragment>
            }
        </Paper>

    return (
        <div>

            <Box sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, width: '100%', zIndex: '4' }}>
                {
                    workflowState.initialOptions ? withInitialOptions : noInitialOptions
                }
            </Box>
        </div>

    );
}

export default DataProvisioningWorkflow